import { Box, TextField, Autocomplete } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useParams, useNavigate } from 'react-router-dom'

import ComboBox from '../../../../../../Components/ComboBox'
import CustomButton from '../../../../../../Components/CustomButton/CustomButton'
import { Input } from '../../../../../../Components/Input'
import { makeGetRequest, makePostRequest } from '../../../../../../utils/api'
import { currentDate } from '../../../../../../utils/helpers'
import urls from '../../../../../../utils/urls'

export default function CreateOperationForm({ setOperations, openForm, setModifi, setOpenForm }) {
  const { id } = useParams()
  const [open, setOpen] = useState(true)
  const [typeObject, setTypeObject] = useState(0)
  // const [typeCreditors, setTypeCreditors] = useState('')
  const [contacts, setContacts] = useState([])
  const [financier, setFinancier] = useState([])

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      ImmoObjectID: parseInt(id),
      BeginDate: currentDate(),
      TotalLoans: '',
      Creditor: '',
      Contact: '',
      Financier: '',
      YearsDuration: '',
    },
  })

  useEffect(() => {
    fetchAllFinanciers()
  }, [])

  const fetchAllContacts = async (cat) => {
    const url = urls.getAllContacts
    const { data, status } = await makeGetRequest(url + '?Category=' + cat, {}, true)
    if (status === 200) {
      const filterContacts = []
      data.forEach((v) => {
        filterContacts.push({ label: `${v.Nom}`, id: v.id })
      })
      setContacts([...filterContacts])
    }
  }

  const fetchAllFinanciers = async () => {
    const url = urls.getAllFinanciers
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterContacts = []
      data.forEach((v) => {
        filterContacts.push({ label: `${v.Nom}`, id: v.id })
      })
      setFinancier([...filterContacts])
    }
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    reset()
  }
  const typeCreditor = [
    { label: 'Institutions_financiere', id: 1 },
    { label: 'Famille', id: 2 },
    { label: 'Amis', id: 3 },
  ]
  const onSubmit = async (data) => {
    const payload = {
      ...data,
    }
    payload.ImmoObjectID = parseInt(id)

    const response = await makePostRequest(urls.curdImmoFinancement, payload, {}, true)
    if (response.status === 201) {
      let url = `${urls.curdPlanImmoFinancementViewDashboard}`
      const response = await makeGetRequest(url + '?ImmoObjectID=' + id, {}, true)
      if (response.status === 200) {
        setOperations({ ...response.data })
        handleClose()
        setModifi(true)
        setOpenForm(false)
      }
    }
  }

  return (
    <>
      <CustomButton onClick={handleClickOpen}>créer</CustomButton>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle>Ajout Financement</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="BeginDate"
              label="Begin Date"
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="TotalLoans"
              label="Total Loans"
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                // setTypeCreditors(j.label)
                // if(j.id===1){fetchAllFinanciers()}
                if (j.id === 2 || j.id === 3) {
                  fetchAllContacts(j.label)
                }
                setTypeObject(j.id)
                setValue('Creditor', j.label)
              }}
              label="Creditor"
              data={typeCreditor}
              name="Creditor"
              required={true}
            />
            {typeObject === 1 && (
              <Controller
                name={'Financier'}
                control={control}
                // defaultValue={'Maison'}
                rules={{
                  required: true,
                }}
                render={({ field }) => (
                  <Autocomplete
                    disablePortal
                    sx={{ marginTop: '7px' }}
                    options={financier}
                    getOptionLabel={(option) =>
                      option?.label ?? financier.find(({ id }) => id === option)?.label ?? ''
                    }
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    {...field}
                    renderInput={(params) => (
                      <TextField required {...params} size="small" label="Financier" />
                    )}
                    onChange={(_event, data) => field.onChange(data?.id || '')}
                  />
                )}
              />
            )}
            {(typeObject === 2 || typeObject === 3) && (
              // <Input
              //   control={control}
              //   inputProps={{
              //     variant: 'outlined',
              //     type: 'text',
              //     required: true,
              //     size: 'small',
              //   }}
              //   rules={{ required: true }}
              //   name='Contact'
              //   label='Contact'
              // />
              <Controller
                name={'Contact'}
                control={control}
                // defaultValue={'Maison'}
                rules={{
                  required: true,
                }}
                render={({ field }) => (
                  <Autocomplete
                    disablePortal
                    sx={{ marginTop: '7px' }}
                    options={contacts}
                    getOptionLabel={(option) =>
                      option?.label ?? contacts.find(({ id }) => id === option)?.label ?? ''
                    }
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    {...field}
                    renderInput={(params) => (
                      <TextField required {...params} size="small" label="Contact" />
                    )}
                    onChange={(_event, data) => field.onChange(data?.id || '')}
                  />
                )}
              />
            )}

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="YearsDuration"
              label="Years Duration"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
